export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  REG_REQUEST: "USERS_REG_REQUEST",
  REG_SUCCESS: "USERS_REG_SUCCESS",
  REG_FAILURE: "USERS_REG_FAILURE",
  USERINFO_REQUEST: "USERS_INFO_REQUEST",
  USERINFO_SUCCESS: "USERS_INFO_SUCCESS",
  USERINFO_FAILURE: "USERS_INFO_FAILURE",
  LOGOUT: "USERS_LOGOUT",
  SET_ERROR: "SET_ERROR",
  DISABLE_ERROR: "DISABLE_ERROR",
  CONFLIST_REQUEST: "USERS_CONFLIST_REQUEST",
  CONFLIST_SUCCESS: "USERS_CONFLIST_SUCCESS",
  CONFLIST_FAILURE: "USERS_CONFLIST_FAILURE",
  CONFLIST_STUDENT_REQUEST: "USERS_CONFLIST_STUDENT_REQUEST",
  CONFLIST_STUDENT_SUCCESS: "USERS_CONFLIST_STUDENT_SUCCESS",
  CONFLIST_STUDENT_FAILURE: "USERS_CONFLIST_STUDENT_FAILURE",

  SITELIST_REQUEST: "USERS_SITELIST_REQUEST",
  SITELIST_SUCCESS: "USERS_SITELIST_SUCCESS",
  SITELIST_FAILURE: "USERS_SITELIST_FAILURE",
  ADDCONF_REQUEST: "USERS_ADDCONF_REQUEST",
  ADDCONF_SUCCESS: "USERS_ADDCONF_SUCCESS",
  ADDCONF_FAILURE: "USERS_ADDCONF_FAILURE",
  TEAMORG_REQUEST: "USERS_TEAMORG_REQUEST",
  TEAMORG_SUCCESS: "USERS_TEAMORG_SUCCESS",
  TEAMORG_FAILURE: "USERS_TEAMORG_FAILURE",
  SET_CONF: "USERS_SET_CONF",
  SET_CONF_SELECTED: "USERS_SET_CONF_SELECTED",
  SET_SITE: "USERS_SET_SITE",
  EDITCONF_REQUEST: "USERS_EDITCONF_REQUEST",
  EDITCONF_SUCCESS: "USERS_EDITCONF_SUCCESS",
  EDITCONF_FAILURE: "USERS_EDITCONF_FAILURE",

  DELCONF_REQUEST: "USERS_DELCONF_REQUEST",
  DELCONF_SUCCESS: "USERS_DELCONF_SUCCESS",
  DELCONF_FAILURE: "USERS_DELCONF_FAILURE",

  SCHEDULE_REQUEST: "USERS_SCHEDULE_REQUEST",
  SCHEDULE_SUCCESS: "USERS_SCHEDULE_SUCCESS",
  SCHEDULE_FAILURE: "USERS_SCHEDULE_FAILURE",

  SECTIONS_REQUEST: "USERS_SECTIONS_REQUEST",
  SECTIONS_SUCCESS: "USERS_SECTIONS_SUCCESS",
  SECTIONS_FAILURE: "USERS_SECTIONS_FAILURE",

  TEAM_REQUEST: "USERS_TEAM_REQUEST",
  TEAM_SUCCESS: "USERS_TEAM_SUCCESS",
  TEAM_FAILURE: "USERS_TEAM_FAILURE",

  LOADING: "ANY_REQUEST_LOADING",
};

export const CHINA_MODE_APPROVED = "CHINA_MODE_APPROVED";

export const LANG_LIST = ["ru", "en", "cn"];

export const serverUrl = process.env.REACT_APP_SERVER_URL;
//export const serverUrl = "https://api1.naviconf.com/";
// Origin фронта, на который провайдер возвращает человека после OAuth. Задаётся отдельно
// от serverUrl и хардкоду не подлежит: api1 возвращает на demo.naviconf.com, api —
// на lk.naviconf.com, а маркер входа из приложения лежит в localStorage одного origin
// и на другом не прочитается (src/LoginPage/OAuthStartPage.js).
export const frontendUrl = (process.env.REACT_APP_FRONTEND_URL || "").replace(/\/+$/, "");
// Провайдеры, вход через которых мобильное приложение открывает снаружи. Список закрытый:
// на /oauth-start можно прийти с любой строкой в адресе, а по ней строится переход на бэкенд.
export const nativeOAuthProviders = ["vkontakte", "leader-id", "yandex", "sber-id"];
export const landingDomain = process.env.REACT_APP_LANDING_DOMAIN || "naviconf.com";
export const helpUrl = process.env.REACT_APP_HELP_URL || `https://${landingDomain}/help`;
export const agrUrl = process.env.REACT_APP_POLICY_URL;
//export const agrUrl =https://naviconf.com/privacy-policy;
export const defaultLang = process.env.REACT_APP_DEFAULT_LANG;
export const vkontakteOAuthDisabled = process.env.REACT_APP_OAUTH_VK_DISABLED === "true" || false;
export const leaderIdOAuthDisabled = process.env.REACT_APP_OAUTH_LEADERID_DISABLED === "true" || false;
export const alipayOAuthDisabled = process.env.REACT_APP_OAUTH_ALIPAY_DISABLED === "true" || false;
export const yandexOAuthDisabled = process.env.REACT_APP_OAUTH_YANDEX_DISABLED === "true" || false;
// Сбер ID. Провайдер у бэкенда называется "sber-id" (auth/sber-id, api/token/sber-id),
// а страница возврата — /sber-callback: имена не совпадают, как и у leader-id.
// В китайском контуре выключен всегда: не все его сборки передают REACT_APP_OAUTH_SBER_DISABLED
// (sync-web.sh приложения его не знает), а без флага кнопка появлялась.
export const sberOAuthDisabled =
  process.env.REACT_APP_OAUTH_SBER_DISABLED === "true" ||
  process.env.REACT_APP_CHINA_MODE === "true";
export const rentEnabled = process.env.REACT_APP_RENT_ENABLED === "true" || false;
export const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || "₽";
// Сервер чата с оператором (Live Helper Chat). Пусто — чат не подключается вовсе.
export const lhcUrl = (process.env.REACT_APP_LHC_URL || "").replace(/\/+$/, "");
// Окружение в метке отдела конференции в LHC (demo-123 / prod-123): инсталляция LHC одна
// на демо и прод, а id конференций в их базах пересекаются. Пусто — чат везде общий.
export const lhcDepartmentPrefix = process.env.REACT_APP_LHC_DEPARTMENT_PREFIX || "";
// Режим «визитка»: упрощённый UI для WebView мобильного приложения (src/CardApp/).
// В компонентах использовать только эту константу. Исключение — src/index.js,
// где нужен литерал process.env, иначе webpack не вырежет мёртвую ветку с кабинетом.
export const cardMode = process.env.REACT_APP_CARD_MODE === "true";
